module.exports = __webpack_public_path__ + "static/media/24-5.d977253d.mp3";